import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var getURLParameters = function getURLParameters(url) {
  return (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(function (a, v) {
    return a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1), a;
  }, {});
};
export var prevChild = function prevChild() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  var i = index;

  while (i > -1) {
    i--;
    if (!data[i]) return;

    if (data[i] && data[i].value && data[i].value.replace(/(\n|\s)/g, '') !== '' || data[i].type !== 'text') {
      if (!/^rehype:/.test(data[i].value) || data[i].type !== 'comment') return;
      return data[i];
    }
  }

  return;
};
export var nextChild = function nextChild() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  var tagName = arguments.length > 2 ? arguments[2] : undefined;
  var i = index;

  while (i < data.length) {
    i++;

    if (tagName) {
      var element = data[i];

      if (element && element.value && element.value.replace(/(\n|\s)/g, '') !== '' || data[i] && data[i].type === 'element') {
        return element.tagName === tagName ? element : undefined;
      }
    } else {
      var _element = data[i];
      if (!_element || _element.type !== 'text' && _element.type !== 'comment' || _element.type === 'text' && _element.value.replace(/(\n|\s)/g, '') !== '') return;

      if (_element.type === 'comment') {
        if (!/^rehype:/.test(_element.value)) return;
        var nextNode = nextChild(data, i, 'pre');
        if (nextNode) return;
        return _element;
      }
    }
  }

  return;
};
/**
 * 获取代码注视的位置
 * @param data 数据
 * @param index 当前数据所在的位置
 * @returns 返回 当前参数数据 Object，`{}`
 */

export var getCommentObject = function getCommentObject(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value;
  var param = getURLParameters(value.replace(/^rehype:/, ''));
  Object.keys(param).forEach(function (keyName) {
    if (param[keyName] === 'true') {
      param[keyName] = true;
    }

    if (param[keyName] === 'false') {
      param[keyName] = false;
    }

    if (typeof param[keyName] === 'string' && !/^0/.test(param[keyName]) && !isNaN(+param[keyName])) {
      param[keyName] = +param[keyName];
    }
  });
  return param;
};
export var propertiesHandle = function propertiesHandle(defaultAttrs, attrs, type) {
  if (type === 'string') {
    return _objectSpread(_objectSpread({}, defaultAttrs), {}, {
      'data-config': JSON.stringify(_objectSpread(_objectSpread({}, attrs), {}, {
        rehyp: true
      }))
    });
  } else if (type === 'attr') {
    return _objectSpread(_objectSpread({}, defaultAttrs), attrs);
  }

  return _objectSpread(_objectSpread({}, defaultAttrs), {}, {
    'data-config': _objectSpread(_objectSpread({}, attrs), {}, {
      rehyp: true
    })
  });
};